import { z } from 'zod';

export const DatiqCellLabelSchema = z.object({
    label: z.string(),
    subLabel: z.string().optional(),
    strong: z.boolean().optional(),
    data: z.unknown().optional(),
    icon: z.string().optional(),
    iconColor: z.string().optional(),
    hideLabel: z.boolean().optional(),
    id: z.string().optional(),
    align: z.string().optional(),
});

export interface IDatiqCellLabel extends z.infer<typeof DatiqCellLabelSchema> {}
